import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import KvSectionStore from '@src/pages/main/components/kv-section/store';
import Link from '@src/components/link';
import $$tracker from '@src/tracker';
const styles = require('./index.less');

const KvSection = ({ store }) => {
  store.use();
  return (
    <div className={cx(styles.firstScreenRoot, store.isActive && styles.currentPage)}>
      <div className={styles.topLeftLogo}>{store.topLeftLogo.map(item => <img key={item.id} src={item.src} alt="" className={styles.logo} />)}</div>
      <div className={styles.leftActivity}>
        {store.leftActivity.map(item => (
          <div key={item.id} className={styles.activityItem} onClick={item.onClick}>
            <img src={item.src} alt="" className={styles.activityImg} />
          </div>
        ))}
      </div>
      <div className={styles.slogan} />
      <Link className={cx(styles.playPv)} onClick={store.onClickPlayPv} />
      <Link
        className={cx(styles.officialBtn)}
        href={store.officialUrl}
        target={'_blank'}
        onClick={() => {
          $$tracker.clickGoGw();
        }}
      />
      {store.down_load_ready && (
        <div className={styles.downloadBox}>
          {store.downloadList.map(item => (
            <Link
              key={item.id}
              href={item.href}
              target={'_blank'}
              onClick={() => {
                $$tracker.clickDownload(item.id);
              }}
            >
              <img src={item.img} alt="" className={styles.downloadImg} />
              <img src={item.hoverImg} alt="" className={styles.downloadImgHover} />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default wrapStore(KvSection, KvSectionStore);
